import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'key-value-editor',
    template: require('./key-value-editor.component.html'),

    styles: [`
        .key-value-action {
            margin: 0 3px;
            float: right;
            cursor: pointer;
        }
        .key-value-action:hover {
            color: #A9A9A9;
        }
        .key-value-action-column {
            width: 55px;
        }
        .box-datatable-responsive {
            top: unset;
        }
    `]
})
export class KeyValueEditorComponent implements OnInit {

    @Input() form: FormGroup;

    @Input() name: string;

    @Input() label: string;

    @Input() description: string;

    @Input() values: string;

    @Input() addHeader: boolean;

    @Input() showName: boolean = true;

    @Input() headerLabels: string[];

    @Input() editOnly: boolean;

    valueList: { key: string, value: string }[] = [];
    addNewRow: boolean;
    newKey: string;
    newValue: string;
    editing: boolean[] = [];

    private control: FormControl;

    ngOnInit(): void {
        if (!this.values) {
            this.values = "{}";
        }
        let valueObj = JSON.parse(this.values);
        this.valueList = Object.getOwnPropertyNames(valueObj).map(key => { return { key: key, value: valueObj[key] } });

        this.control = new FormControl(this.values);
        this.form.setControl(this.name, this.control);
    }

    isEditing(): boolean {
        return this.editing.some(e => e) || this.addNewRow;
    }

    addRow(): void {
        this.newKey = '';
        this.newValue = '';
        this.addNewRow = true;
    }

    completeAddNewRow(): void {
        this.valueList.push({ key: this.newKey, value: this.newValue });
        this.addNewRow = false;
        this.updateValue();
    }

    editRow(index: number): void {
        if (!this.isEditing()) {
            this.newKey = this.valueList[index]['key'];
            this.newValue = this.valueList[index]['value'];
            this.editing[index] = true;
        }
    }

    cancelEditRow(index: number): void {
        this.editing[index] = false;
    }

    removeRow(index: number): void {
        this.valueList.splice(index, 1);
        this.updateValue();
    }

    completeEditRow(index: number): void {
        this.valueList[index].key = this.newKey;
        this.valueList[index].value = this.newValue;
        this.editing[index] = false;
        this.updateValue();
    }

    private updateValue(): void {
        let val = {};
        this.valueList.forEach(v => val[v.key] = v.value);
        this.control.setValue(JSON.stringify(val));
    }

    reset(): void {
        let valueObj = JSON.parse(this.values);
        this.valueList = Object.getOwnPropertyNames(valueObj).map(key => { return { key: key, value: valueObj[key] } });
        this.control.setValue(this.values);
    }

}